/* hp-mhd.js — PDP best-before date display.
 *
 * Uses the theme's resolved on:variant:change event, just like hp-delivery.js.
 * ISO date-only values are formatted by token replacement instead of Date so
 * browser timezone conversion can never shift the displayed calendar day.
 */
(function () {
  function formatIsoDate(value, format) {
    if (typeof value !== 'string') return '';
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return '';

    const tokens = { '%Y': match[1], '%m': match[2], '%d': match[3] };
    return (format || '%d.%m.%Y').replace(/%[Ymd]/g, function (token) {
      return tokens[token];
    });
  }

  function initRoot(root) {
    if (root.dataset.hpMhdInit === '1') return;

    const dateElement = root.querySelector('[data-hp-mhd-date]');
    const dataElement = root.querySelector('[data-hp-mhd-data]');
    if (!dateElement || !dataElement) return;

    let mhdData = {};
    try {
      mhdData = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    root.dataset.hpMhdInit = '1';
    const format = root.getAttribute('data-hp-mhd-format') || '%d.%m.%Y';

    function renderFor(variantId) {
      const entry = variantId != null ? mhdData[String(variantId)] : null;
      const date = formatIsoDate(entry && entry.expiry, format);
      dateElement.textContent = date;
      root.hidden = !date;
    }

    renderFor(root.getAttribute('data-hp-mhd-current'));

    // Fremd-Events ausfiltern (Bug 2026-09-20, gleiche Regel wie hp-delivery.js):
    // Der Picker im Auswahlfenster (quick-add-drawer) und Picker anderer
    // Produkt-Sektionen feuern dasselbe Event bubbling bis zum document; ohne
    // Filter verschwand das MHD des Hauptprodukts beim Variantenwechsel im Fenster.
    // Bewusst KEIN Sektions-Vergleich: dieser Block sitzt im Abschnitt «details»,
    // der Picker des eigenen Produkts im Abschnitt «main».
    const ownHandleMatch = /\/products\/([^/?#]+)/.exec(window.location.pathname);
    const ownHandle = ownHandleMatch ? decodeURIComponent(ownHandleMatch[1]) : '';
    function isForeignPicker(src) {
      if (!src || !src.closest) return false;
      const drawer = src.closest('quick-add-drawer, .js-quickbuy');
      if (drawer) return !drawer.contains(root);
      const m = /\/products\/([^/?#]+)/.exec(src.getAttribute('data-url') || '');
      return !!(m && ownHandle && decodeURIComponent(m[1]) !== ownHandle);
    }

    document.addEventListener('on:variant:change', function (event) {
      if (isForeignPicker(event.target)) return;
      const variant = event.detail && event.detail.variant;
      renderFor(variant ? variant.id : null);
    });

    window.addEventListener('popstate', function () {
      renderFor(new URLSearchParams(window.location.search).get('variant'));
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hp-mhd-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
